var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('base-button',{staticClass:"float-right",attrs:{"icon":"","type":"primary"},on:{"click":_vm.printDocument}},[_c('i',{staticClass:"fa fa-print"})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }